import https from 'https'
import axios from 'axios'
import Head from 'next/head'
import getServerSideAccessToken from '@utilities/auth/server/getServerSideAccessToken'
import ItemDetail from '@components/ItemPage'
import bidapi from '../../../api/bidapi'

type Token = string | null | undefined

export async function getServerSideProps(context: any) {
  const token = await getServerSideAccessToken(context)
  const { auctionId, itemId } = context.params

  try {
    const instance = axios.create({
      httpsAgent: new https.Agent({
        rejectUnauthorized: false,
      }),
      baseURL,
    })

    const { data: auction } = await instance.get(
      `/auction/auctionDetails/${auctionId}`
    )

    let [
      { data: auctionItem },
      { data: relatedAuctions },
      { data: pageNumber },
      allOffers,
      {
        data: { items },
      },
    ] = await Promise.all([
      instance.get(`/item/itemDetails/${auctionId}/${itemId}`),
      instance.get(`/auction/getAuctions?categories=${auction.category}`),
      instance.get(`/item/getPagetIdInAuction/${auctionId}/${itemId}`),
      fetchOffers(token, context),
      token
        ? instance.get('/item/getUpdateItemsInfo', {
            params: { itemIds: [itemId] },
            paramsSerializer: { indexes: null },
          })
        : { data: { items: null } },
    ])

    if (items) {
      const [itemDataForUser] = items
      auctionItem = { ...auctionItem, ...itemDataForUser }
    }

    return {
      props: {
        auction,
        auctionItem,
        relatedAuctions,
        pageNumber,
        itemId,
        allOffers: allOffers,
        fetchItemUrl: `${baseURL}/item/itemDetails/${auctionId}/${itemId}`,
      },
    }
  } catch (e: any) {
    const error = (e.response?.data || e).message || ''
    console.error(error || e)
    if (error.match(/java\.lang\.String.*java\.lang\.Integer/)) {
      // on wrong item id error considered redirect level up
      return {
        redirect: {
          destination: `/auction-detail/${auctionId}/1`,
          permanent: false,
        },
      }
    }
    throw e
  }
}

const baseURL = process.env.NEXT_PUBLIC_AUCTION_API || ''

const fetchOffers = async (token: Token, context: any) => {
  if (!token) return null

  const userOffers = await bidapi({
    url: `${baseURL}/offers/offerActiveItemList`,
    token,
    context,
  })
  return userOffers?.map((offer: any) => offer.id)
}

const Page = (props: any) => (
  <>
    <Head>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
    <ItemDetail {...props} />
  </>
)

export default Page
